import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

function SEO({
  description,
  lang,
  meta,
  keywords,
  title,
  imagePost,
  opengraphImage,
  opengraphUrl,
  bodyClass,
  schema = null,
  image = null,
  opengraphType = 'website',
}) {
  const data = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
        }
      }
    }
  `);

  const metaDescription = description || data.site.siteMetadata.description;

  const path = opengraphUrl?.replace(process.env.SITE_URL, '') || '';
  const url = `${data.site.siteMetadata.siteUrl}${path}`;

  const twitterImageUrl = imagePost || '';

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={title}
        titleTemplate={`%s`}
        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: opengraphType,
          },
          {
            property: `og:image`,
            content: data.site.siteMetadata.siteUrl + image,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: data.site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: title,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
          {
            property: 'twitter:image',
            content: twitterImageUrl,
          },
          {
            property: 'twitter:image:src',
            content: twitterImageUrl,
          },
        ]
          .concat(
            keywords.length > 0
              ? {
                  name: `keywords`,
                  content: keywords.join(`, `),
                }
              : []
          )
          .concat(meta)}
      >
        <script type="application/ld+json">{`${schema?.raw}`}</script>
        <body className={bodyClass} />
      </Helmet>
    </>
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  bodyClass: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  twitterImageUrl: PropTypes.string,
};

export default SEO;
